import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Formik, FieldArray, Field } from 'formik';
import * as Yup from 'yup';

import isEmpty from "../../../../utils/helpers";
import TextInput from "../../../../components/UI/TextInput";

import { hideModal } from '../../../../actions/modal.actions';
import {getAdmin, getModalData, getUser, getUserPermission,} from '../../../../selectors';
import { getPartnerProperties, updatePartnerProperties } from '../../../../actions/admin.actions';
import { getUserSummary } from "../../../../actions/user.actions";
import LoadingModalContent from '../../../../components/Modal/LoadingModalContent';
import {toastr} from "react-redux-toastr";

class EditPartnerPropertiesModal extends Component {
    state = {
        alertMessage: '',
        isLoading: true,
    };

    componentDidMount() {
        console.log(this.props)
        if (this.props.modalProps.row) {
            this.props.getPartnerProperties(this.props.modalProps.row.id)
                .then(() => {
                    this.setState({
                        isLoading: false,
                    })
                })
        } else {
            this.setState({
                isLoading: false,
            })
        }
    }

    componentWillUnmount() {
    }

    formSchema = () => {
        return Yup.object().shape({
            properties: Yup.array().of(
                Yup.object().shape({
                    id: Yup.number().nullable(),
                    key: Yup.string().required('Required').test('max-255', 'Maximum 255 characters.', val => !val || val.length < 255)
                })
            )
        });
    }

    hideModal = () => {
        this.props.hideModal();
    }

    formSubmit = (values, actions) => {
        const { modalProps } = this.props;
        const partnerId = this.props.modalProps.row.id;

        this.setState({ alertMessage: '' }, () => {
            const postData = {
                properties: Object.values(values.properties)
            };
            this.props.updatePartnerProperties(partnerId, postData).then((response) => {
                if(response.data.success){
                    toastr.success(response.data.message, { timeOut: 1000, position: "top-center" });
                }
                if (!response.data) {
                    actions.setSubmitting(false);
                    toastr.error('Unknown error. Please try again later', { timeOut: 1000, position: "top-center" });
                    return;
                }
                if (!response.data.success) {
                    actions.setSubmitting(false);
                    toastr.error(response.data.message, { timeOut: 1000, position: "top-center" });
                    return;
                }

                this.hideModal();
                this.props.modalProps.reloadPartners();
            });
        });

        this.hideModal();
    }

    render() {
        const { alertMessage } = this.state;
        const {partnerProperties, modalProps } = this.props;

        return (
            <Fragment>
                <div className="modal" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                    {this.state.isLoading && (
                        <LoadingModalContent
                            modalTitle={'Partner Properties'}
                            submitButtonLabel={'Save'}
                        />
                    )}
                    {!this.state.isLoading && (
                        <Formik
                            initialValues={{
                                properties: !partnerProperties
                                || partnerProperties.length === 0 ?
                                    [{ id: '', key: '', value: '' }] : partnerProperties
                            }}
                            validationSchema={this.formSchema()}
                            onSubmit={this.formSubmit}
                            render={({
                                handleChange,
                                handleSubmit,
                                handleBlur,
                                values,
                                errors,
                                touched,
                                isSubmitting,
                                setFieldValue,
                                setFieldTouched }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="modal-dialog">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title">Partner Properties</h5>
                                                <button onClick={this.hideModal} type="button" className="close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body cmv-form form-horizontal">
                                                <div className="order-service-order-wrapper">
                                                    <div>
                                                        <h4>{modalProps?.row?.name || ''}</h4>
                                                        <p className="billing-job-id">
                                                            {modalProps?.row?.description || ''}
                                                            <br />
                                                            #{modalProps?.row?.id ?? ''}
                                                        </p>
                                                    </div>
                                                </div>
                                                <FieldArray
                                                    name="properties"                 
                                                    render={arrayHelpers => (
                                                    <div>
                                                        {values.properties.map((property, index) => (
                                                        <fieldset key={index}>
                                                            <legend className="as-label">Property { index + 1 }</legend>
                                                            <Field name={`properties.${index}.id`} type="hidden" />
                                                            <TextInput
                                                                label="Key"
                                                                name={`properties.${index}.key`}
                                                                value={property.key}
                                                                onChange={(e) => {
                                                                    handleChange(e);
                                                                    if (e.target.value.length >= 255) {
                                                                        setFieldTouched(`properties.${index}.key`, true, false);
                                                                    }
                                                                }}
                                                                onBlur={handleBlur}
                                                                errors={errors}
                                                                touched={touched}
                                                                disabled={!modalProps.canEditProperties}
                                                                maxLength={255}
                                                            />
                                                            <TextInput
                                                                label="Value"
                                                                name={`properties.${index}.value`}
                                                                value={property.value}
                                                                onChange={(e) => {
                                                                    handleChange(e);
                                                                }}
                                                                onBlur={handleBlur}
                                                                errors={errors}
                                                                touched={touched}
                                                                disabled={!modalProps.canEditProperties}
                                                            />
                                                            {modalProps.canEditProperties &&
                                                            <div className="form-group text-right">
                                                                <button type="button" className="btn btn-danger"
                                                                        onClick={() => arrayHelpers.remove(index)}>
                                                                    Remove
                                                                </button>
                                                            </div>
                                                            }
                                                        </fieldset>
                                                        ))}
                                                        {modalProps.canEditProperties &&
                                                        <div className="form-group text-right">
                                                            <button type="button" className="btn btn-success"
                                                                onClick={() => arrayHelpers.push({ id: '', key: '', value: '' })} >
                                                                Add Another
                                                            </button>
                                                        </div>
                                                        }
                                                    </div>
                                                    )}
                                                />
                                            </div>
                                            <div className="modal-footer">
                                                <button onClick={this.hideModal} className="btn" type="button">
                                                    Cancel
                                                </button>
                                                {modalProps.canEditProperties &&
                                                <button disabled={isSubmitting} type="submit" className="btn btn-primary">
                                                    Save
                                                </button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )}
                        />
                    )}
                </div>
                <div className="modal-backdrop show" tabIndex="1" />
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const partner = getAdmin(state).partner,
        partnerProperties = getAdmin(state).partnerProperties,
        modalProps = getModalData(state).modalProps,
        currentUser = getUser(state).user;

    return {
        partner,
        partnerProperties,
        modalProps,
        currentUser
    };
};

const mapDispatchToProps = {
    hideModal,
    getPartnerProperties,
    updatePartnerProperties,
    getUserSummary
};

export default connect(mapStateToProps, mapDispatchToProps)(EditPartnerPropertiesModal);